import type { FlowKind, FlowRole } from './flowModel'

const KIND_COLORS: Record<FlowKind, string> = {
  in: 'var(--flow-in)',
  kept: 'var(--flow-kept)',
  between: 'var(--flow-between)',
  out: 'var(--flow-out)',
}

// Payers and payees wear the color of the money they send or take;
// own accounts stay a quiet slate so the flows carry the color.
const ROLE_COLORS: Record<FlowRole, string> = {
  payer: KIND_COLORS.in,
  received: 'var(--flow-account)',
  spent: 'var(--flow-account)',
  account: 'var(--flow-account)',
  from: 'var(--flow-account)',
  to: 'var(--flow-account)',
  payee: KIND_COLORS.out,
}

export function flowKindColor(kind: FlowKind): string {
  return KIND_COLORS[kind]
}

export function flowRoleColor(role: FlowRole): string {
  return ROLE_COLORS[role]
}
